/* EDX – Trang chủ tím (Agent 12, 18/10/2026). Không thư viện ngoài. */
(function () {
  if (window.edxTcReady) return;
  window.edxTcReady = true;

  function each(sel, root, fn) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }

  /* Tab: [data-edx-tabs="nhom"] chứa nút [data-tab="i"]; khung [data-panel="i"][data-group="nhom"] */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tab]');
    if (!btn) return;
    var bar = btn.closest('[data-edx-tabs]');
    if (!bar) return;
    var group = bar.getAttribute('data-edx-tabs');
    var scope = btn.closest('[data-edx-scope]') || document;
    each('[data-tab]', bar, function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
    each('[data-panel][data-group="' + group + '"]', scope, function (p) {
      p.hidden = p.getAttribute('data-panel') !== btn.getAttribute('data-tab');
    });
  });

  /* Slider: [data-edx-slider] có .edx-ban__slide, nút [data-prev] [data-next], chấm [data-go] */
  function Slider(root) {
    var slides = root.querySelectorAll('[data-slide]');
    if (!slides.length) return;
    var i = 0, n = slides.length, ms = parseInt(root.getAttribute('data-auto') || '0', 10) * 1000, t = null;
    function show(k) {
      i = (k + n) % n;
      Array.prototype.forEach.call(slides, function (s, j) { s.classList.toggle('is-on', j === i); s.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
      each('[data-go]', root, function (d) { d.setAttribute('aria-current', parseInt(d.getAttribute('data-go'), 10) === i ? 'true' : 'false'); });
    }
    function play() { stop(); if (ms > 0 && n > 1) t = setInterval(function () { show(i + 1); }, ms); }
    function stop() { if (t) clearInterval(t); t = null; }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-prev]')) { show(i - 1); play(); }
      else if (e.target.closest('[data-next]')) { show(i + 1); play(); }
      else { var g = e.target.closest('[data-go]'); if (g) { show(parseInt(g.getAttribute('data-go'), 10)); play(); } }
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); play(); }
    });
    show(0); play();
  }

  /* Video: [data-edx-video] chứa [data-vitem] (ẩn), hiển thị 1 lớn + 4 nhỏ */
  function Video(root) {
    var items = root.querySelectorAll('[data-vitem]');
    var n = items.length; if (!n) return;
    var i = 0;
    var main = root.querySelector('[data-vmain]');
    var sides = root.querySelectorAll('[data-vside]');
    function render() {
      var cur = items[i];
      main.innerHTML = cur.innerHTML;
      Array.prototype.forEach.call(sides, function (s) {
        var d = parseInt(s.getAttribute('data-vside'), 10);
        if (n < 2) { s.hidden = true; return; }
        var k = ((i + d) % n + n) % n;
        if (k === i || (Math.abs(d) === 2 && n < 5)) { s.hidden = true; return; }
        var cov = (items[k].content || items[k]).querySelector('[data-cover]');
        s.innerHTML = cov ? cov.outerHTML : '';
        s.setAttribute('data-k', k);
        s.setAttribute('aria-label', items[k].getAttribute('data-title') || 'Video');
        s.hidden = false;
      });
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-vprev]')) { i = (i - 1 + n) % n; render(); return; }
      if (e.target.closest('[data-vnext]')) { i = (i + 1) % n; render(); return; }
      var s = e.target.closest('[data-vside]');
      if (s && s.hasAttribute('data-k')) { i = parseInt(s.getAttribute('data-k'), 10); render(); return; }
      var p = e.target.closest('[data-vplay]');
      if (p) {
        var v = main.querySelector('video');
        if (v) { p.hidden = true; v.controls = true; v.muted = false; v.play(); }
      }
    });
    render();
  }

  /* Tư vấn nhanh */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-tv-opt]');
    if (!o) return;
    var box = o.closest('[data-edx-tv]');
    each('[data-tv-opt]', box, function (b) { b.setAttribute('aria-pressed', b === o ? 'true' : 'false'); });
    var res = box.querySelector('[data-tv-res]');
    res.querySelector('[data-tv-hint]').textContent = o.getAttribute('data-hint');
    var a = res.querySelector('[data-tv-link]');
    a.href = o.getAttribute('data-link') || a.href;
    res.hidden = false;
  });

  /* Thêm cả bộ vào giỏ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-edx-addall]');
    if (!b) return;
    e.preventDefault();
    var ids = (b.getAttribute('data-edx-addall') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    b.disabled = true;
    var old = b.textContent; b.textContent = b.getAttribute('data-wait') || '…';
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    }).catch(function () { b.disabled = false; b.textContent = old; alert(b.getAttribute('data-err') || 'Chưa thêm được, chị thử lại nhé.'); });
  });

  /* Vừa xem (đọc danh sách do mục "Chai bạn đã xem" ở trang sản phẩm ghi lại) */
  function Seen(root) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('edx_seen') || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list) || !list.length) return;
    var max = parseInt(root.getAttribute('data-max') || '6', 10);
    var ul = root.querySelector('ul'), tpl = root.querySelector('template');
    var base = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    Promise.all(list.slice(0, max).map(function (h) {
      return fetch(base + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var n = 0;
      items.forEach(function (p) {
        if (!p) return;
        var li = tpl.content.firstElementChild.cloneNode(true);
        li.querySelector('a').href = p.url;
        var img = li.querySelector('img');
        if (p.featured_image) { img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300'; img.alt = p.title; } else { img.remove(); }
        li.querySelector('.edx-brand').textContent = p.vendor || '';
        li.querySelector('.edx-pname').textContent = p.title;
        li.querySelector('.edx-price').textContent = Math.round(p.price / 100).toLocaleString('vi-VN') + '₫';
        ul.appendChild(li); n++;
      });
      if (n) root.hidden = false;
    });
    root.addEventListener('click', function (e) {
      if (!e.target.closest('[data-vx-clear]')) return;
      try { localStorage.removeItem('edx_seen'); } catch (err) {}
      root.hidden = true;
    });
  }

  function init(scope) {
    each('[data-edx-slider]', scope, function (r) { if (!r._edx) { r._edx = 1; Slider(r); } });
    each('[data-edx-video]', scope, function (r) { if (!r._edx) { r._edx = 1; Video(r); } });
    each('[data-edx-seen]', scope, function (r) { if (!r._edx) { r._edx = 1; Seen(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();